import {
  getParentNode,
  insertNodes,
  ELEMENT_MEDIA_EMBED,
} from '@udecode/plate';

export const insertMediaEmbed = (
  editor,
  {
    url = '',
    key = ELEMENT_MEDIA_EMBED,
  },
) => {
  if (!editor.selection) return;
  const selectionParentEntry = getParentNode(editor, editor.selection);
  if (!selectionParentEntry) return;
  const [, path] = selectionParentEntry;
  insertNodes(
    editor,
    {
      type: key,
      url,
      children: [{ text: '' }],
      width: '100%',
    },
    { at: path },
  );
};
